import axios from "axios";
import { Get, Post } from "../server";

// 查询
export const getBounsPointerSettings = () => {
    return Get("/admin/creditsConf/creditsConf");
};

// 修改
export const changeBounsPointerSettings = (params: any) => {
    return axios({
        url: `/admin/creditsConf/creditsConf`,
        method: "put",
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
        },
        data: params,
        baseURL: process.env.REACT_APP_BASE_URL,
    });
};

